<template>
    <div v-if="visiable" class="tz-dialog">
       <div class="dlg-line">
           {{ msg }}
       </div>
       <div>
           <b-button @click="cancel">取消</b-button>
           <b-button @click="confirm">确认</b-button>
       </div>
    </div>    
</template>
<script>
export default {
    props:{
        visiable:{
            type: Boolean,
            default: true
        },
        ok: {
            type: Boolean,
            default: false
        },
        msg: {
            type: String,
            default: ''
        }
    },
    methods:{
        cancel(){
            this.$router.back();
        },
        confirm(){
            this.$emit("update:ok",true)
        }
    }
}
</script>
<style scoped>
.tz-dialog{
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    color: white;
    font-size: 200%;
    font-weight: bold;
}
.dlg-line{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/dialog/confirmdialog.vue